"use client";

import { useMemo } from "react";
import { iconLibraries, IconLibrary } from "@/lib/utils/icons";

interface IconProps {
  name: string; // e.g., "FaHome", "MdSettings"
  size?: number;
  color?: string;
  className?: string;
}

export default function DynamicIcon({
  name,
  size = 20,
  color,
  className = "",
}: IconProps) {
  const IconComponent = useMemo(() => {
    try {
      const prefix = name.substring(0, 2).toLowerCase() as IconLibrary;

      // Check if library exists
      if (iconLibraries[prefix]) {
        const IconLib = iconLibraries[prefix] as any;
        if (IconLib[name]) {
          return IconLib[name];
        }
      }

      // Alternative: Try all libraries
      for (const library of Object.values(iconLibraries)) {
        if ((library as any)[name]) {
          return (library as any)[name];
        }
      }

      return null;
    } catch {
      return null;
    }
  }, [name]);

  if (!IconComponent) {
    console.warn(`Icon "${name}" not found`);
    return <span className={`inline-block ${className}`}>□</span>;
  }

  return (
    <IconComponent
      aria-label={name}
      size={size}
      color={color}
      className={className}
    />
  );
}
